import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Importing JavaScript libraries
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'jquery/dist/jquery.min.js'
import 'waypoints/lib/jquery.waypoints.min.js'  // Correct waypoints import
import 'owl.carousel/dist/owl.carousel.min.js'

// FontAwesome is still imported as it's from node_modules
import '@fortawesome/fontawesome-free/css/all.min.css'

createApp(App)
  .use(router)
  .mount('#app')
